import { LEDGER_ENTRY_TYPE } from 'Data/payments.js'

export function getTransactionsWithNotes(transaction) {
  switch (transaction.type) {
    case LEDGER_ENTRY_TYPE.CHARGE:
    case LEDGER_ENTRY_TYPE.ADJUSTMENT:
      return transaction.entries.filter(t => !!t.notes)
    default:
      return transaction.notes ? [transaction] : []
  }
}
